/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Calendar {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Create Event.
   *
   * @tags Calendar
   * @name CreateEvent
   * @summary Create Event
   * @request POST:/api/calendar/events
   * @secure
   */
  createEvent = (data, params = {}) =>
    this.http.request({
      path: `/api/calendar/events`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List Events.
   *
   * @tags Calendar
   * @name ListEvents
   * @summary List Events
   * @request GET:/api/calendar/events
   * @secure
   */
  listEvents = (query, params = {}) =>
    this.http.request({
      path: `/api/calendar/events`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get Event.
   *
   * @tags Calendar
   * @name GetEvent
   * @summary Get Event
   * @request GET:/api/calendar/events/{event_id}
   * @secure
   */
  getEvent = (eventId, params = {}) =>
    this.http.request({
      path: `/api/calendar/events/${eventId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update Event.
   *
   * @tags Calendar
   * @name UpdateEvent
   * @summary Update Event
   * @request PUT:/api/calendar/events/{event_id}
   * @secure
   */
  updateEvent = (eventId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/events/${eventId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Event.
   *
   * @tags Calendar
   * @name DeleteEvent
   * @summary Delete Event
   * @request DELETE:/api/calendar/events/{event_id}
   * @secure
   */
  deleteEvent = (eventId, params = {}) =>
    this.http.request({
      path: `/api/calendar/events/${eventId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Export Event.
   *
   * @tags Calendar
   * @name ExportEvent
   * @summary Export Event
   * @request GET:/api/calendar/events/{event_id}/export
   * @secure
   */
  exportEvent = (eventId, params = {}) =>
    this.http.request({
      path: `/api/calendar/events/${eventId}/export`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get Google Link.
   *
   * @tags Calendar
   * @name GetGoogleLink
   * @summary Get Google Link
   * @request GET:/api/calendar/events/{event_id}/google-link
   * @secure
   */
  getGoogleLink = (eventId, params = {}) =>
    this.http.request({
      path: `/api/calendar/events/${eventId}/google-link`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List Syncs.
   *
   * @tags Calendar
   * @name ListSyncs
   * @summary List Syncs
   * @request GET:/api/calendar/syncs
   * @secure
   */
  listSyncs = (params = {}) =>
    this.http.request({
      path: `/api/calendar/syncs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create Sync.
   *
   * @tags Calendar
   * @name CreateSync
   * @summary Create Sync
   * @request POST:/api/calendar/syncs
   * @secure
   */
  createSync = (data, params = {}) =>
    this.http.request({
      path: `/api/calendar/syncs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update Sync.
   *
   * @tags Calendar
   * @name UpdateSync
   * @summary Update Sync
   * @request PUT:/api/calendar/syncs/{sync_id}
   * @secure
   */
  updateSync = (syncId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/syncs/${syncId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Sync.
   *
   * @tags Calendar
   * @name DeleteSync
   * @summary Delete Sync
   * @request DELETE:/api/calendar/syncs/{sync_id}
   * @secure
   */
  deleteSync = (syncId, params = {}) =>
    this.http.request({
      path: `/api/calendar/syncs/${syncId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Create Schedule.
   *
   * @tags Calendar
   * @name CreateSchedule
   * @summary Create Schedule
   * @request POST:/api/calendar/schedules
   * @secure
   */
  createSchedule = (data, params = {}) =>
    this.http.request({
      path: `/api/calendar/schedules`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List Schedules.
   *
   * @tags Calendar
   * @name ListSchedules
   * @summary List Schedules
   * @request GET:/api/calendar/schedules
   * @secure
   */
  listSchedules = (query, params = {}) =>
    this.http.request({
      path: `/api/calendar/schedules`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get Schedule.
   *
   * @tags Calendar
   * @name GetSchedule
   * @summary Get Schedule
   * @request GET:/api/calendar/schedules/{schedule_id}
   * @secure
   */
  getSchedule = (scheduleId, params = {}) =>
    this.http.request({
      path: `/api/calendar/schedules/${scheduleId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update Schedule.
   *
   * @tags Calendar
   * @name UpdateSchedule
   * @summary Update Schedule
   * @request PUT:/api/calendar/schedules/{schedule_id}
   * @secure
   */
  updateSchedule = (scheduleId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/schedules/${scheduleId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Schedule.
   *
   * @tags Calendar
   * @name DeleteSchedule
   * @summary Delete Schedule
   * @request DELETE:/api/calendar/schedules/{schedule_id}
   * @secure
   */
  deleteSchedule = (scheduleId, params = {}) =>
    this.http.request({
      path: `/api/calendar/schedules/${scheduleId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Replace Windows.
   *
   * @tags Calendar
   * @name ReplaceWindows
   * @summary Replace Windows
   * @request PUT:/api/calendar/schedules/{schedule_id}/windows
   * @secure
   */
  replaceWindows = (scheduleId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/schedules/${scheduleId}/windows`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Upsert Overrides.
   *
   * @tags Calendar
   * @name UpsertOverrides
   * @summary Upsert Overrides
   * @request PUT:/api/calendar/schedules/{schedule_id}/overrides
   * @secure
   */
  upsertOverrides = (scheduleId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/schedules/${scheduleId}/overrides`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Override.
   *
   * @tags Calendar
   * @name DeleteOverride
   * @summary Delete Override
   * @request DELETE:/api/calendar/availability-overrides/{override_id}
   * @secure
   */
  deleteOverride = (overrideId, params = {}) =>
    this.http.request({
      path: `/api/calendar/availability-overrides/${overrideId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description List Event Types.
   *
   * @tags Calendar
   * @name ListEventTypes
   * @summary List Event Types
   * @request GET:/api/calendar/event-types
   * @secure
   */
  listEventTypes = (params = {}) =>
    this.http.request({
      path: `/api/calendar/event-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create Event Type.
   *
   * @tags Calendar
   * @name CreateEventType
   * @summary Create Event Type
   * @request POST:/api/calendar/event-types
   * @secure
   */
  createEventType = (data, params = {}) =>
    this.http.request({
      path: `/api/calendar/event-types`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get Event Type.
   *
   * @tags Calendar
   * @name GetEventType
   * @summary Get Event Type
   * @request GET:/api/calendar/event-types/{event_type_id}
   * @secure
   */
  getEventType = (eventTypeId, params = {}) =>
    this.http.request({
      path: `/api/calendar/event-types/${eventTypeId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update Event Type.
   *
   * @tags Calendar
   * @name UpdateEventType
   * @summary Update Event Type
   * @request PUT:/api/calendar/event-types/{event_type_id}
   * @secure
   */
  updateEventType = (eventTypeId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/event-types/${eventTypeId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Event Type.
   *
   * @tags Calendar
   * @name DeleteEventType
   * @summary Delete Event Type
   * @request DELETE:/api/calendar/event-types/{event_type_id}
   * @secure
   */
  deleteEventType = (eventTypeId, params = {}) =>
    this.http.request({
      path: `/api/calendar/event-types/${eventTypeId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Add Host.
   *
   * @tags Calendar
   * @name AddHost
   * @summary Add Host
   * @request POST:/api/calendar/event-types/{event_type_id}/hosts
   * @secure
   */
  addHost = (eventTypeId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/event-types/${eventTypeId}/hosts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Remove Host.
   *
   * @tags Calendar
   * @name RemoveHost
   * @summary Remove Host
   * @request DELETE:/api/calendar/event-types/{event_type_id}/hosts/{user_id}
   * @secure
   */
  removeHost = (eventTypeId, userId, params = {}) =>
    this.http.request({
      path: `/api/calendar/event-types/${eventTypeId}/hosts/${userId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Link Property.
   *
   * @tags Calendar
   * @name LinkProperty
   * @summary Link Property
   * @request POST:/api/calendar/event-types/{event_type_id}/properties
   * @secure
   */
  linkProperty = (eventTypeId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/event-types/${eventTypeId}/properties`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Unlink Property.
   *
   * @tags Calendar
   * @name UnlinkProperty
   * @summary Unlink Property
   * @request DELETE:/api/calendar/event-types/{event_type_id}/properties/{property_id}
   * @secure
   */
  unlinkProperty = (eventTypeId, propertyId, params = {}) =>
    this.http.request({
      path: `/api/calendar/event-types/${eventTypeId}/properties/${propertyId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description List Bookings.
   *
   * @tags Calendar
   * @name ListBookings
   * @summary List Bookings
   * @request GET:/api/calendar/bookings
   * @secure
   */
  listBookings = (query, params = {}) =>
    this.http.request({
      path: `/api/calendar/bookings`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get Booking.
   *
   * @tags Calendar
   * @name GetBooking
   * @summary Get Booking
   * @request GET:/api/calendar/bookings/{booking_id}
   * @secure
   */
  getBooking = (bookingId, params = {}) =>
    this.http.request({
      path: `/api/calendar/bookings/${bookingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update booking start/end times (drag-and-drop reschedule).
   *
   * @tags Calendar
   * @name UpdateBookingTimes
   * @summary Update Booking Times
   * @request PATCH:/api/calendar/bookings/{booking_id}
   * @secure
   */
  updateBookingTimes = (bookingId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/bookings/${bookingId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Confirm Booking.
   *
   * @tags Calendar
   * @name ConfirmBooking
   * @summary Confirm Booking
   * @request POST:/api/calendar/bookings/{booking_id}/confirm
   * @secure
   */
  confirmBooking = (bookingId, params = {}) =>
    this.http.request({
      path: `/api/calendar/bookings/${bookingId}/confirm`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Decline Booking.
   *
   * @tags Calendar
   * @name DeclineBooking
   * @summary Decline Booking
   * @request POST:/api/calendar/bookings/{booking_id}/decline
   * @secure
   */
  declineBooking = (bookingId, params = {}) =>
    this.http.request({
      path: `/api/calendar/bookings/${bookingId}/decline`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Cancel Booking.
   *
   * @tags Calendar
   * @name CancelBooking
   * @summary Cancel Booking
   * @request POST:/api/calendar/bookings/{booking_id}/cancel
   * @secure
   */
  cancelBooking = (bookingId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/bookings/${bookingId}/cancel`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Complete Booking.
   *
   * @tags Calendar
   * @name CompleteBooking
   * @summary Complete Booking
   * @request POST:/api/calendar/bookings/{booking_id}/complete
   * @secure
   */
  completeBooking = (bookingId, params = {}) =>
    this.http.request({
      path: `/api/calendar/bookings/${bookingId}/complete`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description No Show Booking.
   *
   * @tags Calendar
   * @name NoShowBooking
   * @summary No Show Booking
   * @request POST:/api/calendar/bookings/{booking_id}/no-show
   * @secure
   */
  noShowBooking = (bookingId, params = {}) =>
    this.http.request({
      path: `/api/calendar/bookings/${bookingId}/no-show`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Calendar
   * @name ScheduleSelfGuidedTour
   * @summary Schedule Contactless Self-Guided Tour
   * @request POST:/api/calendar/self-guided-tours/schedule
   * @secure
   */
  scheduleSelfGuidedTour = (data, params = {}) =>
    this.http.request({
      path: `/api/calendar/self-guided-tours/schedule`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Calendar
   * @name ScheduleSelfGuidedTour2
   * @summary Schedule Contactless Self-Guided Tour
   * @request POST:/api/calendar/self-guided-tours
   * @originalName scheduleSelfGuidedTour
   * @duplicate
   * @secure
   */
  scheduleSelfGuidedTour2 = (data, params = {}) =>
    this.http.request({
      path: `/api/calendar/self-guided-tours`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Calendar
   * @name ListSelfGuidedTours
   * @summary List Self-Guided Tours
   * @request GET:/api/calendar/self-guided-tours
   * @secure
   */
  listSelfGuidedTours = (query, params = {}) =>
    this.http.request({
      path: `/api/calendar/self-guided-tours`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Calendar
   * @name GetSelfGuidedTour
   * @summary Get Self-Guided Tour
   * @request GET:/api/calendar/self-guided-tours/{tour_id}
   * @secure
   */
  getSelfGuidedTour = (tourId, params = {}) =>
    this.http.request({
      path: `/api/calendar/self-guided-tours/${tourId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Calendar
   * @name VerifyVisitorIdentity
   * @summary Verify Visitor Identity & Dispatch Access Code
   * @request POST:/api/calendar/self-guided-tours/{tour_id}/verify
   * @secure
   */
  verifyVisitorIdentity = (tourId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/self-guided-tours/${tourId}/verify`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Calendar
   * @name GetTourAccessCode
   * @summary Retrieve Tour Access Code During Valid Window
   * @request GET:/api/calendar/self-guided-tours/{tour_id}/access-code
   * @secure
   */
  getTourAccessCode = (tourId, query, params = {}) =>
    this.http.request({
      path: `/api/calendar/self-guided-tours/${tourId}/access-code`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Calendar
   * @name RecordTourCheckin
   * @summary Record Check-in Access Event
   * @request POST:/api/calendar/self-guided-tours/{tour_id}/checkin
   * @secure
   */
  recordTourCheckin = (tourId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/self-guided-tours/${tourId}/checkin`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Calendar
   * @name RecordTourCheckin2
   * @summary Record Check-in Access Event
   * @request POST:/api/calendar/self-guided-tours/{tour_id}/access-checkin
   * @originalName recordTourCheckin
   * @duplicate
   * @secure
   */
  recordTourCheckin2 = (tourId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/self-guided-tours/${tourId}/access-checkin`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Calendar
   * @name RecordTourCheckout
   * @summary Record Checkout & Lock Re-arming
   * @request POST:/api/calendar/self-guided-tours/{tour_id}/checkout
   * @secure
   */
  recordTourCheckout = (tourId, params = {}) =>
    this.http.request({
      path: `/api/calendar/self-guided-tours/${tourId}/checkout`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Calendar
   * @name RevokeTourAccess
   * @summary Revoke Tour Access Code
   * @request POST:/api/calendar/self-guided-tours/{tour_id}/revoke
   * @secure
   */
  revokeTourAccess = (tourId, query, params = {}) =>
    this.http.request({
      path: `/api/calendar/self-guided-tours/${tourId}/revoke`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Visitor or manager checkout recording departure and revoking access PIN.
   *
   * @tags Calendar
   * @name ToursCheckoutAlias
   * @summary Record Checkout & Lock Re-arming
   * @request POST:/api/calendar/tours/{tour_id}/checkout
   * @secure
   */
  toursCheckoutAlias = (tourId, params = {}) =>
    this.http.request({
      path: `/api/calendar/tours/${tourId}/checkout`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Resolve how to book a visit for a property. Public — no auth required. Returns the property's active event-type slug so the booking UI doesn't hardcode one. 404 if the property has no active visit configuration.
   *
   * @tags Calendar
   * @name GetPropertyBookingConfig
   * @summary Get Property Booking Config
   * @request GET:/api/calendar/public/properties/{slug}/booking-config
   */
  getPropertyBookingConfig = (slug, params = {}) =>
    this.http.request({
      path: `/api/calendar/public/properties/${slug}/booking-config`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Resolve how to book a standalone event type (org-level, not property- scoped). Public — no auth required. 404 if unknown or inactive.
   *
   * @tags Calendar
   * @name GetEventBookingConfig
   * @summary Get Event Booking Config
   * @request GET:/api/calendar/public/org/{org_slug}/events/{event_slug}/booking-config
   */
  getEventBookingConfig = (orgSlug, eventSlug, params = {}) =>
    this.http.request({
      path: `/api/calendar/public/org/${orgSlug}/events/${eventSlug}/booking-config`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get available booking slots for an event type. Public — no auth required.
   *
   * @tags Calendar
   * @name GetAvailableSlots
   * @summary Get Available Slots
   * @request GET:/api/calendar/public/slots
   */
  getAvailableSlots = (query, params = {}) =>
    this.http.request({
      path: `/api/calendar/public/slots`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Create a booking. Public — no auth required.
   *
   * @tags Calendar
   * @name CreateBooking
   * @summary Create Booking
   * @request POST:/api/calendar/public/bookings
   */
  createBooking = (data, params = {}) =>
    this.http.request({
      path: `/api/calendar/public/bookings`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Check booking status by UID. Public — returns limited info, no PII.
   *
   * @tags Calendar
   * @name GetBookingStatus
   * @summary Get Booking Status
   * @request GET:/api/calendar/public/bookings/{uid}
   */
  getBookingStatus = (uid, params = {}) =>
    this.http.request({
      path: `/api/calendar/public/bookings/${uid}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Opt a booking in to a self-guided tour. Public — the booking uid is the credential. Idempotent: a repeat call returns the tour already arranged.
   *
   * @tags Calendar
   * @name RequestSelfGuidedTour
   * @summary Request Self Guided Tour
   * @request POST:/api/calendar/public/bookings/{uid}/self-guided-tour
   */
  requestSelfGuidedTour = (uid, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/public/bookings/${uid}/self-guided-tour`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description A visitor's tour pass. Public — the tour id is the credential.
   *
   * @tags Calendar
   * @name GetTourPass
   * @summary Get Tour Pass
   * @request GET:/api/calendar/public/tours/{tour_id}
   */
  getTourPass = (tourId, params = {}) =>
    this.http.request({
      path: `/api/calendar/public/tours/${tourId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description The lock code: only once staff verified the visitor, the visit is confirmed and its time window is open. 403 otherwise.
   *
   * @tags Calendar
   * @name GetTourAccessCode2
   * @summary Get Tour Access Code
   * @request GET:/api/calendar/public/tours/{tour_id}/access-code
   * @originalName getTourAccessCode
   * @duplicate
   */
  getTourAccessCode2 = (tourId, params = {}) =>
    this.http.request({
      path: `/api/calendar/public/tours/${tourId}/access-code`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description The visitor acknowledges arrival with their code. Repeating it is a no-op.
   *
   * @tags Calendar
   * @name CheckInTour
   * @summary Check In Tour
   * @request POST:/api/calendar/public/tours/{tour_id}/check-in
   */
  checkInTour = (tourId, data, params = {}) =>
    this.http.request({
      path: `/api/calendar/public/tours/${tourId}/check-in`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description The visitor records departure, completing the tour and re-arming the smart lock.
   *
   * @tags Calendar
   * @name CheckoutTour
   * @summary Checkout Tour
   * @request POST:/api/calendar/public/tours/{tour_id}/checkout
   */
  checkoutTour = (tourId, params = {}) =>
    this.http.request({
      path: `/api/calendar/public/tours/${tourId}/checkout`,
      method: "POST",
      format: "json",
      ...params,
    });
}
